module.exports = __webpack_public_path__ + "static/people.01f8ae27.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/people.jpg
// module id = 544
// module chunks = 0